import type { DialogType } from './dialog.types';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  name: '',
  size: '2/3',
  position: 'top-center',
} satisfies DialogType as DialogType;

const DialogSlice = createSlice({
  name: 'dialog',
  initialState,
  reducers: (create) => ({
    openBigTopCenterDialog: create.reducer<string>((state, action) => {
      state.name = action.payload;
      state.position = 'top-center';
      state.size = '1/2';
    }),
    openMediumTopCenterDialog: create.reducer<string>((state, action) => {
      state.name = action.payload;
      state.position = 'top-center';
      state.size = '1/2';
    }),
    openMediumCenterDialog: create.reducer<string>((state, action) => {
      state.name = action.payload;
      state.position = 'center';
      state.size = '1/2';
    }),
    closeDialog: create.reducer(() => initialState),
  }),
  selectors: {
    dialog: (dialog) => dialog,
    name: (dialog) => dialog.name,
    position: (dialog) => dialog.position,
    size: (dialog) => dialog.size,
  },
});

export default DialogSlice;
